<main class="container-lg px-0 pt-3 pb-3 pb-lg-5">
  <h2 *ngIf="user" class="mb-4 px-3 px-md-0"> {{ 'ACCOUNT.WELCOME_MESSAGE' | translate : {username: user.fname} }}</h2>
  <div *ngIf="cashierUrl; else noUrl">
    <iframe [src]="cashierUrl" width="100%" height="750px" title="cashier" ></iframe>
  </div>
</main>

<ng-template #noUrl>
  <div class="container text-center py-5">
    <h3>{{'ACCOUNT.NOLINK_MESSAGE' | translate}}</h3>
    <h4>{{'ACCOUNT.NOLINK_TIP' | translate}}</h4>
  </div>
</ng-template>

